import { Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import React, { ReactElement } from 'react';
import EllipsisText from '../common/components/EllipsisText';
import { H, V } from '../common/Layout';
import { useStyling } from '../common/Theme';

type LabelValueDisplayProps = {
    label: string | ReactElement;
    value: string | ReactElement;
    labelOnTop?: boolean;
    labelSize?: number;
    labelSx?: SxProps;
    valueSx?: SxProps;
    wrapperSx?: SxProps;
    onClickValue?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    labelValueInline?: boolean;
};

export const LabelValueDisplay = ({
    label,
    value,
    labelOnTop = true, // By Default, Label will be displayed on top
    labelSize = 12, // Default size for label in px
    labelSx,
    valueSx,
    wrapperSx,
    onClickValue = () => {},
    labelValueInline = false
}: LabelValueDisplayProps) => {
    const { theme } = useStyling();
    const valueSize = Number(labelSize) + 2; // value should always be greater by 2px than Label
    const Wrapper = labelValueInline ? H : V;
    return (
        <div>
            {labelOnTop ? (
                <Wrapper gap={labelValueInline ? 1 : 0} sx={{ ...wrapperSx }}>
                    <EllipsisText
                        text={label}
                        sx={{ fontSize: `${labelSize}px`, color: theme.palette.text.secondary, ...labelSx }}
                    />
                    <Typography
                        variant={'body2'}
                        sx={{ fontSize: `${valueSize}px`, color: theme.palette.text.primary, ...valueSx }}
                        onClick={onClickValue}
                    >
                        {value}
                    </Typography>
                </Wrapper>
            ) : (
                <Wrapper gap={labelValueInline ? 1 : 0} sx={{ ...wrapperSx }}>
                    <Typography
                        variant={'body2'}
                        sx={{ fontSize: `${valueSize}px`, color: theme.palette.text.primary, ...valueSx }}
                        onClick={onClickValue}
                    >
                        {value}
                    </Typography>
                    <EllipsisText
                        text={label}
                        sx={{ fontSize: `${labelSize}px`, color: theme.palette.text.secondary, ...labelSx }}
                    />
                </Wrapper>
            )}
        </div>
    );
};
